import axios from "axios";
import { base_url, base_url_algo, headers } from "../constants";

// ---------- Get stock news
export const getStockNews = async (ticker, page_size) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/news/tickers?tickers=${ticker}&page_size=${page_size}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }
    console.error("Get watchlists error:", error);
    return { success: false, error };
  }
};

// ---------- Get stock financials
export const getStockFinancials = async (
  ticker,
  period,
  financial_type
) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const params = new URLSearchParams();

    if (period) {
      params.append("period", period);
    }

    if (financial_type) {
      params.append("financial_type", financial_type);
    }

    const response = await axios.get(
      `${base_url}/api/v1/stocks/financials/${ticker}?${params.toString()}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };

  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }
    console.error("Get stock financials error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation by ticker
export const getValuationByTicker = async (
  ticker,
  include_history = false
) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/ticker/${ticker}`,
      {
        params: { include_history: false },
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation by ticker error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation by stock ID
export const getValuationByStockId = async (stockId) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/stock/${stockId}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation by stock ID error:", error);
    return { success: false, error };
  }
};

// ---------- Get top-rated stocks
export const getTopRatedValuations = async () => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/top-rated`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get top-rated valuations error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuations by grade
export const getValuationsByGrade = async (grade) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/by-grade/${grade}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      });

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuations by grade error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation distribution
export const getValuationDistribution = async () => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/distribution`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      });

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation distribution error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation history by ticker
export const getValuationHistory = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/history/${ticker}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation history error:", error);
    return { success: false, error };
  }
};

// ---------- Get earnings calender
export const getEarningsCalendar = async (month, year, code) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url_algo}/api/earnings/calendar?month=${month}&year=${year}&code=${code}`,
      //   `${base_url_algo}/api/earnings/calendar?month=jan&year=2026&code=sNFAIu2dFIRxj7tNM_coYy5PqrCIAKARu4meea7f7mVUAzFu0KbgDg==`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    console.log(response);
    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation history error:", error);
    return { success: false, error };
  }
};
// https://fa-algo-v2-backend.azurewebsites.net/api/earnings/calendar?month=jan&year=2026&code=sNFAIu2dFIRxj7tNM_coYy5PqrCIAKARu4meea7f7mVUAzFu0KbgDg%3D%3D%27

/**
 * ---------- Get Stocks Screener
 * GET /api/v1/stocks/stock-screener/filter
 *
 * Grade filters are hardcoded in the FE (no metadata endpoint serves them) and are
 * passed straight through in `params`. Supported grade params — each means
 * "this grade or above":
 *   overall_grade, valuation_grade, growth_grade, momentum_grade,
 *   financial_profitability_grade, risk_grade, balance_sheet_quality_grade
 *
 * Every stock row also carries balance_sheet_quality_grade / _score
 * (null until the model backend pushes the new factor).
 */
export const getStocksScreenerQuant = async (params = {}) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  const market = sessionStorage.getItem("selectedMarket") ?? "US";

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/stock-screener/filter`,
      {
        params: { ...params, market_code: market },
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    if (response.data.response_status === "SUCCESS") {
      return { success: true, data: response.data.response_data };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Stock Screener API - Error:", error);
    return { success: false, error };
  }
};

// ---------- Get Stocks Screener -Ratio Types
export const getStocksScreenerRatioTypes = async (params = {}) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    console.log('Stock Screener API - Calling with params:', params);

    const response = await axios.get(
      `${base_url}/api/v1/stocks/ratio-categories/get`,
      {
        params,
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    console.log('Stock Screener API - Response:', response.data);

    // Extract response_data from the API response
    if (response.data.response_status === "SUCCESS") {
      return {
        success: true,
        data: response.data.response_data
      };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }
    console.error('Stock Screener API - Error:', error);
    return { success: false, error };
  }
};

/**
 * ---------- Get Factor Ratings
 * GET /api/v1/stocks/factor-ratings/{ticker}?factor={factor}
 *
 * @param {string} ticker
 * @param {"overall"|"valuation"|"growth"|"momentum"|"financial_profit"|"risk"|"balance_sheet_quality"|null} factor
 *        Omit (or pass "overall") for the summary payload, which carries a grade +
 *        score for all SIX factors — note `risk_*` now means PRICE risk, and
 *        `balance_sheet_quality_*` is the factor split out of it (null until the
 *        model backend pushes it).
 *        Pass a single factor name to get `{ grade, score, breakdown }` for it.
 */
export const getFactorRatings = async (ticker, factor = null) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/factor-ratings/${ticker}`,
      {
        params: factor ? { factor } : {},
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return {
      success: response.data.response_status === "SUCCESS",
      response_data: response.data.response_data
    };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    return { success: false, error };
  }
};

/**
 * ---------- Get Factor Ratings Analysis (AI narrative)
 * POST /comparison/quant-narrative
 *
 * Payload items accept an optional `balance_sheet_quality_grade`. When sent, the
 * narrative references "Balance-Sheet Quality"; when omitted, behaviour is unchanged
 * — so only include the key once the backend is actually returning a grade.
 */
export const getFactorRatingsAnalysis = async (payload) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.post(
      `${base_url}/comparison/quant-narrative`,
      payload, // ✅ send full object
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );

    return {
      success: true,
      data: response.data
    };

  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get factor ratings analysis error:", error);
    return { success: false, error };
  }
};


// ---------- Get Earnings Score
export const getEarnings = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/earnings/ticker/${ticker}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    // ✅ Make sure it returns the correct structure
    return {
      success: response.data.response_status === "SUCCESS",
      response_status: response.data.response_status,
      response_data: response.data.response_data
    };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get factor ratings error:", error);
    return { success: false, error };
  }
};

// ---------- Get Price and Percent change
export const getPricePercentChange = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/earnings/api/v1/stocks/${ticker}/quote`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    console.log(response);
    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    console.error(`Stock details error (${ticker}):`, error);
    return { success: false, error };
  }
};

// ---------- Get Stock Comparison
export const getStockComparison = async (tickers) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/stock-comparisons/get?tickers=${encodeURIComponent(tickers)}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    console.log(response);
    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    console.error(`Stock comparison error:`, error);
    return { success: false, error };
  }
};

// ---------- Get Comparison Narattive
export const getComparisonNarrative = async (payload) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.post(
      `${base_url}/comparison/analysis`,
      payload, // ✅ proper body
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    console.error("Comparison narrative error:", error);
    return { success: false, error };
  }
};

// ---------- Upload Portfolio File
export const uploadPortfolioFile = async (file) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(
      `${base_url}/api/v1/portfolios/portfolio-add/file-upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    return {
      success: false,
      response_message:
        error?.response?.data?.response_message || "File upload failed",
    };
  }
};

// ---------- Get peers
export const getPeers = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  const market = sessionStorage.getItem("selectedMarket") ?? "US";

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/sector-wise-top-stocks/${ticker}`,
      {
        // params: { market_code: market },
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      });

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuations by grade error:", error);
    return { success: false, error };
  }
};

// ---------- Get market types
export const getMarkets = async () => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(`${base_url}/api/v1/markets`, {
      headers: {
        ...headers,
        Authorization: `Bearer ${jwtToken}`,
      },
      withCredentials: false,
    });
    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get markets error:", error);
    return { success: false, error };
  }
};




// ---------- Get fair value chart data
export const getFairValueChart = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/earnings/api/v1/stocks/${ticker}/fair-value-chart`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get fair value chart error:", error);
    return { success: false, error };
  }
};

/* ══════════════════════════════════════════════════════════════════════
   EARNINGS-NOTE TABS  (added 2026-08-10)

   Four per-stock GETs backing the Earnings Review · Sector Context ·
   Thesis · Screen & Catalysts tabs.

   ⚠ Unlike the older /stocks endpoints these return the JSON payload
   DIRECTLY — there is NO response_message / response_data wrapper, and no
   response_status to check. An unknown or inactive ticker returns 404
   { "detail": "Stock XXXX not found" }, which is surfaced as
   { success: false, notFound: true } so the tab can render a clean
   "not covered" state instead of an error.

   Every field in the payload may be null and every list may be empty when
   an engine doesn't cover the stock — callers render what's present.
   All four are read-only; no request bodies anywhere.
══════════════════════════════════════════════════════════════════════ */

const getStockTabPayload = async (ticker, path, label, params) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/${encodeURIComponent(ticker)}/${path}`,
      {
        params,
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    // Payload is returned directly — not wrapped in response_data.
    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401) return { success: false, authExpired: true };
    if (status === 404) {
      return {
        success: false,
        notFound: true,
        detail: error?.response?.data?.detail ?? `Stock ${ticker} not found`,
      };
    }
    if (status === 400) {
      // Only the custom fair-value endpoint 400s — on an invalid anchor name.
      return {
        success: false,
        badRequest: true,
        detail: error?.response?.data?.detail ?? "Invalid request",
      };
    }
    console.error(`Get ${label} error (${ticker}):`, error);
    return { success: false, error };
  }
};

/**
 * ---------- Earnings Review
 * GET /api/v1/stocks/{ticker}/earnings-review
 *
 * Beat/miss history + next report + the management-sentiment score for the
 * latest call (per-dimension quotes, guidance, and a trend series).
 *
 * → { ticker, company_name, sector_name, industry_name, latest_quarter, headline,
 *     price_at_review, variance_table[], data_checks[], guidance_vs_actual,
 *     eps_normalization, key_drivers[], estimate_model_implications[],
 *     watch_items[], next_earnings, quarters[], sentiment, sentiment_history[] }
 *   quarters[]          newest first, up to 8; *_surprise_pct sign gives beat/miss;
 *                       a quarter may carry estimates with null actuals (not yet reported).
 *   variance_table[]    actual vs consensus vs prior periods; rows may carry
 *                       reliable:false (render n/r) or flag:"non_operating_gain".
 *   eps_normalization   the GAAP-vs-operational flag box — null when the quarter
 *                       carried no material one-time gain (hide the box then).
 *   sentiment           composite_score 0–100 + band + band_scale[], qoq_delta,
 *                       summary, composite_formula, guidance{...} (revenue, margin,
 *                       gross_margin_full_year, opex, opex_non_gaap, eps, exclusions),
 *                       dimensions[5] (0–10 prepared/qa/score + quote).
 *                       null for names outside the sentiment universe.
 *   sentiment_history[] newest first, 4-quarter window for S&P 500 names.
 *   key_drivers / estimate_model_implications / watch_items come from the stored
 *   per-quarter note and are null until its seeder has run for the stock.
 */
/**
 * ---------- Summary card (top of the Summary tab)
 * GET /api/v1/stocks/{ticker}/summary
 *
 * → { ticker, company_name, current_price, price_as_of,
 *     intrinsic_value { iv_per_share, upside_downside_pct, margin_of_safety_pct, as_of_date, engine, confidence, declined_reason },
 *     analyst_target { target_price, upside_pct, consensus, num_analysts_3m, num_analysts_12m, as_of },
 *     news_sentiment { composite_score, band, wow_delta, iso_week, week_end, quiet },
 *     earnings_sentiment { composite_score, band, qoq_delta, fiscal_year, fiscal_quarter, transcript_date },
 *     fa_grade { grade, rating, score, rating_type, rating_date },
 *     implied_volatility { as_of, spot, source, weekly{…}, monthly{…} } }   // atm_iv, implied_move are percentages
 */
export const getStockSummary = async (ticker) => getStockTabPayload(ticker, "summary", "summary");

export const getEarningsReview = async (ticker) =>
  getStockTabPayload(ticker, "earnings-review", "earnings review");

/**
 * ---------- Earnings sentiment history (per-quarter reasons)
 * GET /api/v1/stocks/{ticker}/earnings-sentiment/history?quarters=8
 *
 * → { ticker, quarters: [ newest first { fiscal_year, fiscal_quarter, transcript_date,
 *       composite_score, band, qoq_delta, rubric_version, summary, dodged_qa, dodges[],
 *       quotes_verified, comparable_with_prior,
 *       dimensions: [{ key, label, weight, score, prepared, qa, basis, quote, verified,
 *                      prior_score, delta }] }] }
 *   delta is vs the next-older quarter; comparable_with_prior is false across rubric versions.
 *   404 until the backend mounts the route — the tab then falls back to sentiment_history.
 */
export const getEarningsSentimentHistory = async (ticker, quarters = 8) =>
  getStockTabPayload(ticker, "earnings-sentiment/history", "earnings sentiment history", { quarters });

/**
 * ---------- Sector Context
 * GET /api/v1/stocks/{ticker}/sector-context
 *
 * → { ticker, sector_name, industry_name, industry_avg, top_peers[], self_comps,
 *     peg_read, note }
 *   industry_avg  dynamic dict mirroring the TTM financial-ratio columns —
 *                 label = humanized key, values are RAW ratios (format client-side).
 *   top_peers     up to 6, same sector + market, ranked by overall score,
 *                 EXCLUDES the requested ticker — its own comps row is self_comps.
 *                 Each row carries fwd_pe, peg (number or "n/m") + peg_flag,
 *                 fwd_ps, eps_fy1/eps_fy2/eps_growth_fwd_pct, gross_margin_pct,
 *                 model_rank of model_universe, model_score and price_check.
 *   peg_read      the note's "read on PEG" box, templated server-side; null when
 *                 the stock's own PEG is "n/m" (hide the box then).
 *   note          market_dynamics, competitive_landscape[], thematic_shortlist[],
 *                 sector_risk — from the stored note, null until seeded.
 */
export const getSectorContext = async (ticker) =>
  getStockTabPayload(ticker, "sector-context", "sector context");

/**
 * ---------- Thesis
 * GET /api/v1/stocks/{ticker}/thesis
 *
 * → { ticker, narrative, overall_rating, overall_grade, overall_score, rating_date,
 *     valuation_lens, note }
 *   narrative is AI-generated server-side from the current 6-factor ratings and
 *   cached ~4h — repeat calls are cheap, so don't client-cache beyond a session.
 *   null when the stock has no current rating row.
 *   valuation_lens  the note's Valuation table: price, fwd_pe, peg (+peg_flag),
 *                   fwd_ps, model_rank of model_universe, fair_value,
 *                   upside_to_fv, mgmt_sentiment_score/_band, and `reads` —
 *                   the per-row "Read" column, keyed by lens row.
 *   note            stance_label, stance, one_liner, bull[], bear[],
 *                   change_mind_breaks[], change_mind_confirms[] — from the
 *                   stored note, null until seeded.
 */
export const getThesis = async (ticker) =>
  getStockTabPayload(ticker, "thesis", "thesis");

/**
 * ---------- Screen & Catalysts
 * GET /api/v1/stocks/{ticker}/screen-catalysts
 *
 * → { ticker, factors, fair_value, catalysts, factor_screen[], catalyst_calendar[],
 *     screen_read }
 *   factors     6-factor snapshot + model_rank of model_universe. `risk` = PRICE
 *               risk; `balance_sheet_quality` stays null until the model backend
 *               pushes it (hide while null). Scores are model-scale numbers —
 *               display the GRADES, use scores only for sorting.
 *   fair_value  upside_to_fv is a PERCENT (−21.4 = 21.4% above fair value).
 *   catalysts   next_earnings / latest_sentiment, independently nullable.
 *   factor_screen[]     the sector peer set INCLUDING this ticker, rank-ordered.
 *               score_scale "zscore" rows carry comparable dimension values;
 *               "legacy_raw" rows are on the old scale, so render only their
 *               model_rank + composite and BLANK the dimension cells.
 *   catalyst_calendar[] hard next-earnings row first, then company-stated events
 *               from the call. date_label may be an ISO date, "~Q3 FY2027"
 *               (~ = approximate) or "Ongoing"; `source` distinguishes them.
 *   screen_read the screen-read flag box (LLM prose, null until seeded).
 */
export const getScreenCatalysts = async (ticker) =>
  getStockTabPayload(ticker, "screen-catalysts", "screen & catalysts");

/**
 * ---------- Implied Volatility
 * GET /api/v1/stocks/{ticker}/implied-volatility?window_days=30
 *
 * Options-derived expectations: the 30-day ATM implied vol plus, per listed
 * expiry, the ATM strike/IV and the move the options market is pricing in.
 *
 * → { ticker, spot, iv30, window_days, as_of, expiries[] }
 *   iv30        interpolated 30-day ATM implied volatility, ALREADY a percent
 *               (49.4 = 49.4%) — as are the per-expiry `atm_iv` values.
 *   expiries[]  nearest first. Each row:
 *               { expiry, dte, atm_strike, atm_iv,
 *                 implied_move_1sd,     // ±1σ move to expiry, percent
 *                 implied_move,         // expected move (straddle-based), percent
 *                 implied_move_dollars, // the same move in $ terms
 *                 band_low, band_high } // spot ∓ implied_move_dollars
 *   Same contract as the other per-stock tabs: plain JSON (no response_data
 *   wrapper), 404 for unknown/inactive tickers, every field nullable and the
 *   list possibly empty when the name has no listed options.
 */
export const getImpliedVolatility = async (ticker, windowDays = 30) =>
  getStockTabPayload(ticker, "implied-volatility", "implied volatility", {
    window_days: windowDays,
  });

/**
 * ---------- News Sentiment  (added 2026-10-07)
 * GET /api/v1/stocks/{ticker}/news-sentiment?weeks=26
 *
 * factor-alpha's weekly news model: one 0–100 composite per ISO week describing
 * how the company was written about, five quoted dimensions, the stories.
 * → { ticker, covered, data_as_of,
 *     latest: { iso_week, week_start, week_end, composite_score (null = quiet),
 *               band, quiet, wow_delta, baseline_z, evidence_grade, n_scored,
 *               dims_evidenced, dimensions[], stories[], volume{}, model,
 *               prompt_version, scored_at, scale, weights, window },
 *     series[]  oldest first, one point per week (composite_score null on quiet weeks),
 *     data_checks[], scale_note }
 *   Same contract as the other per-stock tabs: plain JSON, 404 for unknown /
 *   inactive tickers; covered=false when nothing is published for the name yet.
 *   Cached server-side (NEWS_TAB_TTL, 15 min) — the data changes once a week.
 */
export const getNewsSentiment = async (ticker, weeks = 26) =>
  getStockTabPayload(ticker, "news-sentiment", "news sentiment", { weeks });


/* ══════════════════════════════════════════════════════════════════════
   VALUATION ENDPOINTS  (added 2026-08-10)

   Same contract as the earnings-note tabs: plain JSON, no response_data
   wrapper, 404 for unknown/inactive tickers. All three are CACHED
   SERVER-SIDE FOR 15 MINUTES — the first request per ticker is the slow
   path and repeats are instant, so the anchor picker can re-query freely.
══════════════════════════════════════════════════════════════════════ */

/**
 * ---------- Intrinsic Value
 * GET /api/v1/stocks/{ticker}/intrinsic-value
 *
 * → { ticker, company_name, intrinsic_value, fcfe_history, sensitivity_grid,
 *     anchor_treatments, data_as_of, financials }
 *   intrinsic_value  null until the IV engine has covered the stock.
 *                    `discount_rate` / `terminal_growth_rate` /
 *                    `tv_share_of_value` are DECIMALS (0.094 = 9.4 %) while
 *                    `margin_of_safety_pct` / `upside_downside_pct` are ALREADY
 *                    percentages — do not multiply those.
 *                    confidence ∈ HIGH | MEDIUM | LOW.
 *                    calculation_method ∈ DCF_FCFE_PROJ (primary) | DCF (fallback);
 *                    fallback stocks may have terminal_growth_tag,
 *                    tv_share_of_value and continuation_years null.
 *   anchor_treatments  the three forecast-anchor legs, each { key, label,
 *                    iv_per_share }, plus { range: { low, high } }. `base` is
 *                    identical to intrinsic_value.iv_per_share. NULL when the
 *                    name has no anchor to vary (asset-manager engine,
 *                    unanchored/fallback rows) — hide the control. A single
 *                    iv_per_share may be null (that leg is not computable);
 *                    `range` covers only the non-null legs. No fixed ordering:
 *                    no_anchor sits below base on LMT and above it on AMAT.
 *   data_as_of       { valuation_date, inputs[{ name, value?, as_of }] }
 *                    `beta` is a RATIO, not a rate — never render it as a %.
 *                    `analyst_consensus.as_of` is the estimates snapshot the
 *                    run anchored on, and is null on rows computed before
 *                    2026-09-09 — render a dash, not a formatted epoch.
 *   financials       income_statement / balance_sheet / cash_flow arrays of FY
 *                    rows, actuals AND projected (is_projected marks forecasts),
 *                    same row shape as /stocks/financials/{ticker}.
 */
export const getIntrinsicValue = async (ticker) =>
  getStockTabPayload(ticker, "intrinsic-value", "intrinsic value");

/**
 * ---------- Valuation history
 * GET /api/v1/stocks/{ticker}/valuation-history?limit=10
 *
 * NOTE: distinct from the older getValuationHistory() above, which hits the
 * separate /api/v1/valuation/history/{ticker} router. This one is on the
 * stocks router and returns three series plus the data_as_of block.
 *
 * → { ticker, data_as_of, intrinsic_value_history[], fair_value_history[],
 *     ratings_history[] } — each series newest-first.
 *
 *   IV and fair-value snapshots accumulate ONE ROW PER DAY starting
 *   2026-08-10, so those arrays are short now and grow daily; ratings history
 *   goes back as far as the rating engine has run.
 *   fair_value = mean of the non-null fv_analyst / fv_iv / fv_historical;
 *   fv_rerate is display-only and never in the mean.
 *   Ratings `score` is the 0–100 overall, but per-FACTOR `score` values are
 *   model z-scores — show the factor `grade` letters, not those raw scores.
 *
 * @param {string} ticker
 * @param {number} limit  1–100, default 10
 */
export const getStockValuationHistory = async (ticker, limit = 10) => {
  const safeLimit = Math.min(100, Math.max(1, Number(limit) || 10));
  return getStockTabPayload(ticker, "valuation-history", "valuation history", {
    limit: safeLimit,
  });
};

/**
 * ---------- Custom fair value
 * GET /api/v1/stocks/{ticker}/fair-value/custom?anchors=fv_iv,fv_rerate
 *
 * Returns the MEAN of the caller-selected anchors. Read-only — nothing is
 * stored. Valid anchors: fv_analyst, fv_iv, fv_historical, fv_rerate.
 * An invalid name 400s with the valid list (surfaced as { badRequest, detail }).
 *
 * ⚠ Omitting the param defaults to the engine trio (analyst + IV + historical),
 * so callers must NOT send an empty selection expecting an empty mean — pass at
 * least one anchor, or don't call.
 *
 * → { ticker, anchors[{ name, value, in_mean }], anchor_count,
 *     custom_fair_value, entry_price, exit_price, band, price_used,
 *     upside_to_custom_fv, stored_fair_value, calculated_at }
 *   in_mean: false means the anchor was selected but is null for this stock.
 *   entry_price / exit_price apply the stock's stored band to the CUSTOM mean.
 *   stored_fair_value is the engine's default mean, for comparison.
 *
 * @param {string} ticker
 * @param {string[]=} anchors  omit for the engine's default trio
 */
export const getCustomFairValue = async (ticker, anchors) => {
  const params =
    Array.isArray(anchors) && anchors.length > 0
      ? { anchors: anchors.join(",") }
      : undefined;
  return getStockTabPayload(ticker, "fair-value/custom", "custom fair value", params);
};

/* ══════════════════════════════════════════════════════════════════════
   INTRINSIC-VALUE SCENARIOS  (added 2026-08-11)

   The artifact's Assumptions panel and "Save version" bar, as APIs:
     POST   .../intrinsic-value/scenario          what-if recompute (nothing stored)
     POST   .../intrinsic-value/scenarios         save a named scenario
     GET    .../intrinsic-value/scenarios         the caller's saved list
     DELETE .../intrinsic-value/scenarios/{id}    remove one
     POST   .../intrinsic-value/scenario/export   Excel workbook download

   Saved scenarios are keyed per USER + STOCK + NAME, so re-saving the same
   name overwrites rather than duplicating.
══════════════════════════════════════════════════════════════════════ */

const postStockTabPayload = async (ticker, path, label, body = {}) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.post(
      `${base_url}/api/v1/stocks/${encodeURIComponent(ticker)}/${path}`,
      body,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status >= 200 && response.status < 300
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401) return { success: false, authExpired: true };
    if (status === 404) {
      return {
        success: false,
        notFound: true,
        detail: error?.response?.data?.detail ?? `Stock ${ticker} not found`,
      };
    }
    if (status === 400) {
      return {
        success: false,
        badRequest: true,
        detail: error?.response?.data?.detail ?? "Invalid request",
      };
    }
    console.error(`Post ${label} error (${ticker}):`, error);
    return { success: false, error };
  }
};

/**
 * ---------- What-if scenario compute
 * POST /api/v1/stocks/{ticker}/intrinsic-value/scenario
 *
 * Read-only — nothing is stored. An EMPTY body replays the stored engine
 * result, which is the sanity check (delta_vs_stored ≈ 0).
 *
 * Assumption keys (all optional):
 *   risk_free_rate / equity_risk_premium / beta  rebuild CoE through CAPM
 *   discount_rate                                direct CoE — wins over the CAPM parts
 *   terminal_growth                              Gordon g (continuation re-evaluated)
 *   consensus_anchor: false                      strip the anchor, run the organic path
 *   fade: false                                  hold consensus at full strength
 *   fade_den                                     decay denominator (3 = full
 *                                                revert, 6 = extended) if a
 *                                                slider is ever wanted instead
 *                                                of the on/off toggle
 *   exit_multiple                                asset-manager engine only
 *   roe5                                         bank engine only
 *   fcfe_overrides: { "2027": 120000000000 }     pin a year's FCFE directly
 *
 * → { ticker, current_price, assumptions, iv_per_share, stored_iv_per_share,
 *     delta_vs_stored, equity_value, pv_projected, pv_terminal,
 *     tv_share_of_value, continuation_years, discount_rate,
 *     discount_rate_source, terminal_growth, calculation_method, shares_used,
 *     years[], sensitivity_grid[] }  — the grid is recentred on the scenario's
 *     own assumptions rather than the stored ones.
 */
export const computeIntrinsicValueScenario = async (ticker, assumptions = {}) =>
  postStockTabPayload(ticker, "intrinsic-value/scenario", "IV scenario", assumptions);

/**
 * ---------- Save a named scenario
 * POST /api/v1/stocks/{ticker}/intrinsic-value/scenarios
 * body: { name, assumptions }
 *
 * The scenario is computed at save time and stored with its result, so the
 * saved list renders without recomputing. 400 when `name` is missing.
 */
export const saveIntrinsicValueScenario = async (ticker, name, assumptions = {}) =>
  postStockTabPayload(ticker, "intrinsic-value/scenarios", "save IV scenario", {
    name,
    assumptions,
  });

/**
 * ---------- List the caller's saved scenarios
 * GET /api/v1/stocks/{ticker}/intrinsic-value/scenarios
 * → newest first: [{ id, name, assumptions, result, created_at }]
 */
export const getIntrinsicValueScenarios = async (ticker) =>
  getStockTabPayload(ticker, "intrinsic-value/scenarios", "IV scenarios");

/**
 * ---------- Delete a saved scenario
 * DELETE /api/v1/stocks/{ticker}/intrinsic-value/scenarios/{id}
 * → { deleted: id }
 */
export const deleteIntrinsicValueScenario = async (ticker, id) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.delete(
      `${base_url}/api/v1/stocks/${encodeURIComponent(ticker)}/intrinsic-value/scenarios/${encodeURIComponent(id)}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    return { success: true, data: response.data };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401) return { success: false, authExpired: true };
    if (status === 404) return { success: false, notFound: true };
    console.error(`Delete IV scenario error (${ticker}/${id}):`, error);
    return { success: false, error };
  }
};

/**
 * ---------- Export a scenario to Excel
 * POST /api/v1/stocks/{ticker}/intrinsic-value/scenario/export
 *
 * Same body as /scenario. Responds with an .xlsx workbook (Summary +
 * per-year Projection sheets) as an attachment, so the response must be read
 * as a blob — NOT JSON. Triggers a browser download and resolves with the
 * filename used.
 */
export const exportIntrinsicValueScenario = async (ticker, assumptions = {}) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.post(
      `${base_url}/api/v1/stocks/${encodeURIComponent(ticker)}/intrinsic-value/scenario/export`,
      assumptions,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        responseType: "blob",
        withCredentials: false,
      }
    );

    // Prefer the server's filename from Content-Disposition when present.
    const disposition =
      response.headers?.["content-disposition"] ?? response.headers?.get?.("content-disposition");
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition ?? "");
    const filename = match ? decodeURIComponent(match[1]) : `${ticker}_IV_scenario.xlsx`;

    const blob = new Blob([response.data], {
      type:
        response.data?.type ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke on the next tick so Safari has time to start the download.
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);

    return { success: true, filename };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401) return { success: false, authExpired: true };
    console.error(`Export IV scenario error (${ticker}):`, error);
    return { success: false, error };
  }
};
